import React, { useRef } from 'react';
import styled from 'styled-components';
import AccordionBox from '@catalogo/ui-americanas-mobile-accordion-box';
import PlusIcon from '@catalogo/ui-americanas-desktop-svg/plus.svg';
import withComboBuyTogether from '@catalogo/service-americanas-product/src/hocs/buy-together';
import ProductCard from './components/product-card';
import ProductMain from './components/product-main';
import Summary from './components/summary';
import { IBuyTogether, IProductCard } from './helpers/interfaces';

export const BuyTogether: React.FC<IBuyTogether> = props => {
  const ref = useRef(null);
  const { mainProduct, products, totalProducts, totalValue, mainPayment, onClickBuyButton } = props;

  const cards = products?.map((product: IProductCard, key: number) => (
    <ProductCard key={product.id} {...product} first={key === 0} />
  ));

  return (
    <AccordionBox
      id="compre-junto"
      title="compre junto"
      htmlElTitle="h2"
      visibilityOnInit={true}
      metricId="compre-junto"
      metricAction="click"
      metricCategory="acordions"
      anchorRef="#compre-junto"
      ref={ref}
      shouldGetElementHeightOnRender={true}
      paddingTitleAxisX={16}
    >
      <Container>
        <ProductMain mainPayment={mainPayment} mainProduct={mainProduct} />
        <PlusContainer>
          <PlusIconUI />
        </PlusContainer>
        <ComboContainer>{cards}</ComboContainer>
        <Summary totalProducts={totalProducts} totalValue={totalValue} onClickBuyButton={onClickBuyButton} />
      </Container>
    </AccordionBox>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const PlusContainer = styled.div`
  margin: 0px 20px 0 -2px;
`;

const PlusIconUI = styled(PlusIcon)`
  height: 24px;
  width: 24px;
  fill: ${({ theme }) => theme.grey.darker};
`;

const ComboContainer = styled.div`
  width: 240px;
  display: flex;
  flex-direction: column;
`;

export default withComboBuyTogether(BuyTogether);
